import {useTranslation} from '@aboutyou/i18n';
import {Button, Divider} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const HelpCenterPageWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const {t} = useTranslation();
  return (
    <Wrapper>
      {children}
      <Divider noMargin />
      <Footer>
        <Button variant="secondary" href="/h">
          {t('Back to help section')}
        </Button>
      </Footer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
`;

const Footer = styled.div`
  padding: 60px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
